var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.71047C23.0495 4.27913 22.7365 2.85849 22.09 1.58047C21.6514 1.05607 21.0427 0.702182 20.37 0.580472C17.5875 0.327998 14.7936 0.224516 12 0.270472C9.21667 0.222431 6.43274 0.322573 3.66003 0.570473C3.11185 0.670189 2.60454 0.927314 2.20003 1.31047C1.30003 2.14047 1.20003 3.56047 1.10003 4.76047C0.954939 6.91804 0.954939 9.08291 1.10003 11.2405C1.12896 11.9159 1.22952 12.5863 1.40003 13.2405C1.5206 13.7455 1.76455 14.2128 2.11003 14.6005C2.51729 15.0039 3.03641 15.2757 3.60003 15.3805C5.75594 15.6466 7.92824 15.7569 10.1 15.7105C13.6 15.7605 16.67 15.7105 20.3 15.4305C20.8775 15.3321 21.4112 15.06 21.83 14.6505C22.11 14.3704 22.3191 14.0276 22.44 13.6505C22.7977 12.5531 22.9733 11.4046 22.96 10.2505C23 9.69047 23 6.31047 23 5.71047ZM9.74003 10.8505V4.66047L15.66 7.77047C14 8.69047 11.81 9.73047 9.74003 10.8505Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e2597fce1f2ee7bebe7714bc6b57e53b.svg";
export { ForwardRef as ReactComponent };